import { Col, Row, Typography } from 'antd';
import React, { useCallback, useContext } from 'react';
import i18n from '~/i18n';
import {
  FileAddOutlined,
  UnorderedListOutlined,
  TransactionOutlined,
  AppstoreAddOutlined,
} from '@ant-design/icons';
import {
  CartActionContext,
  CartStateContext,
} from '~/App/Layout/providers/CartProvider';
import { DialogContext } from '~/providers/DialogProvider';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { useNavigate } from 'react-router-dom';
import './style.css';
import message from '~/utils/message';
import useOpenCustomItemPanel from '../CustomItemPanel/hooks/useOpenCustomItemPanel';
import { CartItem } from '~/types/Cart';
import { useCheckPermission } from '~/store/permission';

const { Text } = Typography;

const BottomBar = () => {
  const items = useContext(CartStateContext);
  const { addToCart, resetCart } = useContext(CartActionContext);
  const { newOrder } = useContext(OrderContext);
  const { openDialog } = useContext(DialogContext);
  const navigate = useNavigate();

  // Custom item.
  const openCustomCartPanel = useOpenCustomItemPanel();
  const handleClickCustomItem = useCallback(() => {
    openCustomCartPanel({
      onSubmit: (cartItem: CartItem) => {
        addToCart(cartItem);
      },
    });
  }, []);

  const checkPermission = useCheckPermission();

  const buttons = [
    {
      key: 'new',
      text: i18n.t('menu_bottom_bar_new'),
      icon: <FileAddOutlined className="menu-icon-text" />,
      onClick: () => {
        const proceed = () => {
          message.success(i18n.t('message_new_order'));
          resetCart();
          newOrder();
        };
        if (items.length) {
          openDialog({
            message: i18n.t('dialog_new_order'),
            okText: i18n.t('dialog_new_order_continue'),
            cancelText: i18n.t('dialog_new_order_cancel'),
            onOk: proceed,
          });
          return;
        }
        proceed();
      },
    },
    {
      key: 'list-order',
      text: i18n.t('menu_bottom_bar_list_order'),
      icon: <UnorderedListOutlined className="menu-icon-text" />,
      onClick: () => {
        navigate('/order');
      },
    },
    ...(checkPermission('cashierTransaction:c')
      ? [
          {
            key: 'create-cashier-transaction',
            text: 'Buat Transaksi',
            icon: <TransactionOutlined />,
            onClick: () => {
              navigate('/cashier-transaction/create');
            },
          },
        ]
      : []),
    {
      key: 'custom-item',
      text: 'Custom Item',
      icon: <AppstoreAddOutlined className="menu-icon-text" />,
      onClick: () => {
        handleClickCustomItem();
      },
    },
  ];
  return (
    <Row className="cart-bottom-bar-row">
      {buttons.map(({ key, text, icon, onClick }) => (
        <Col
          span={6}
          className="cart-bottom-bar-button"
          onClick={onClick}
          key={key}
        >
          {icon}
          <Text className="menu-icon-text">{text}</Text>
        </Col>
      ))}
    </Row>
  );
};

export default BottomBar;
